import type { ReactNode } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AdminAuthProvider } from "./AdminAuthProvider";
import { QueryProvider } from "./QueryProvider";
import { ThemeProvider } from "./ThemeProvider";
import { ToastProvider } from "./ToastProvider";

/**
 * Compose every cross-cutting provider here. main.tsx wraps the router with
 * this single component so providers can be re-ordered without touching the
 * entry point.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AdminAuthProvider>
          <TooltipProvider delayDuration={250} disableHoverableContent>
            <ToastProvider>{children}</ToastProvider>
          </TooltipProvider>
        </AdminAuthProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
